export default __webpack_public_path__ + "static/media/total-icon.1b4c6154.svg";